export const componentModule = {
  CreateDeficiency: "./CreateDeficiency",
  CreateMisstatement: "./CreateMisstatement",
};
